import src from "IMAGE";
export default { src, width: 1680, height: 347, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42gVARwqAMBAMM55tG1I0m6ZBEPz/98R8b5tqDizqGMOOnByKeso2w8oC84zMuydaWRG9oNeDejq0Ejku5Q+x2wVHbkdBwQAAAABJRU5ErkJggg=="};
